'use strict';

const formatDate = require('./format');

class DateDB extends Date {
  constructor(input) {
    if (!input) {
      const d = input ? new Date(input) : new Date();
      const tzDifference = d.getTimezoneOffset();
      const time = d.getTime() - tzDifference * 60 * 1000;
      super(time);
    } else if (input instanceof DateDB) {
      super(input.getTime());
    } else {
      super(input);
    }
  }

  format(template) {
    return formatDate(this, template);
  }

  toString() {
    return this.toJSON();
  }

  static fromDate(input) {
    const d = new Date(input);
    const tzDifference = d.getTimezoneOffset();
    const time = d.getTime() - tzDifference * 60 * 1000;
    return new DateDB(time);
  }

  static now() {
    const d = new Date();
    const tzDifference = d.getTimezoneOffset();
    return d.getTime() - tzDifference * 60 * 1000;
  }

  static clone(dateDB) {
    return new DateDB(dateDB.getTime());
  }
}

module.exports = DateDB;
